@if (toastService.toast(); as toast) {
    <i class="dl-toast__icoon fa-solid" aria-hidden="true"
       [class.fa-circle-info]="!toast.soort"
       [class.fa-circle-exclamation]="!!toast.soort"></i>
    <span class="dl-toast__tekst">{{ toast.sleutel | translate }}</span>
}
